/**
 * BBco – Stock & Save Promo Logic
 *
 * This script controls the visibility and messaging of the “Stock & Save” block
 * on product pages based on variant-level metafields and inventory.
 *
 * DATA SOURCES:
 * - Variant metafields:
 *   - custom.multipack_promo (Boolean)
 *   - custom.multipack_threshold (Integer, e.g. 2 or 3)
 * - Inventory:
 *   - variant.inventory_quantity (injected via Liquid)
 *
 * DISPLAY LOGIC:
 * The block is shown ONLY if:
 * 1. multipack_promo = true
 * 2. inventory_quantity >= multipack_threshold
 *
 * IMPORTANT NOTE ON SHOPIFY INVENTORY POLICY:
 * - Shopify uses "inventory_policy: continue" to allow overselling.
 * - This does NOT mean the product is out of stock.
 * - Do NOT use "continue" as a condition to hide the block.
 * - Always rely on actual inventory_quantity instead.
 *
 * VARIANT HANDLING:
 * - Supports:
 *   - Native input[name="id"] changes
 *   - Shopify theme events (variant:change / variant:changed)
 *   - MutationObserver fallback for programmatic updates
 *
 * LOCALE:
 * - Text is rendered dynamically based on page locale (de / en)
 *
 * ARCHITECTURE:
 * - Liquid injects variant data as JSON
 * - JS handles runtime logic and DOM updates
 *
 * This implementation is intentionally theme-independent and avoids relying
 * on theme-specific inventory structures for long-term stability.
 */

(function () {
  'use strict';

  function initStockSave() {
    const stockBlock = document.getElementById('bbco-stock-save');
    const textEl     = document.getElementById('bbco-stock-save-text');
    const metaEl     = document.getElementById('bbco-variant-meta');
    const localeEl   = document.getElementById('bbco-page-locale');

    if (!stockBlock || !textEl || !metaEl) return;

    let variantMeta = [];
    try {
      variantMeta = JSON.parse(metaEl.textContent.trim());
    } catch (e) {
      console.error('[BBco] Meta JSON parse failed:', e);
      return;
    }

    let locale = 'en';
    try {
      if (localeEl) locale = JSON.parse(localeEl.textContent.trim()).locale || 'en';
    } catch (e) {}
    const isDE = locale.startsWith('de');

    function updateStockBlock(variantId) {
      if (!variantId) { stockBlock.style.display = 'none'; return; }

      const meta = variantMeta.find(v => String(v.id) === String(variantId));

      if (!meta || meta.promo !== true) {
        stockBlock.style.display = 'none';
        return;
      }

      const threshold = Number(meta.threshold) || 3;
      const quantity  = Number(meta.quantity)  || 0;
      const policy    = meta.policy;

      if (quantity < threshold) {
        stockBlock.style.display = 'none';
        return;
      }

      stockBlock.style.display = 'block';
      textEl.innerHTML = isDE
        ? `Sichere dir deine Favoriten mit <strong>10\u00a0% Rabatt</strong> ab\u00a0${threshold}\u00a0Stück\u00a0— automatisch beim Checkout angewendet.`
        : `Secure your favourites with <strong>10% off</strong> when you order\u00a0${threshold} or more\u00a0— applied automatically at checkout.`;
    }

    // Initial load
    const input = document.querySelector('input[name="id"]');
    if (input) updateStockBlock(input.value);

    // variant:changed — Dawn and most modern themes
    document.addEventListener('variant:changed', function (e) {
      const id = e.detail?.variant?.id;
      if (id) updateStockBlock(id);
    });

    // variant:change — some themes use present tense
    document.addEventListener('variant:change', function (e) {
      const id = e.detail?.variant?.id;
      if (id) updateStockBlock(id);
    });

    // Native input change — covers radio buttons and selects
    document.addEventListener('change', function (e) {
      if (e.target?.name === 'id') updateStockBlock(e.target.value);
    });

    // Hidden input value mutation — covers themes that swap value programmatically
    const hiddenInput = document.querySelector('input[name="id"][type="hidden"]');
    if (hiddenInput && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        updateStockBlock(hiddenInput.value);
      }).observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStockSave);
  } else {
    initStockSave();
  }

})();